import { PropsWithChildren, useEffect } from 'react'
import { ThemeProvider } from 'styled-components'
import { useAppThemeProviderController } from './controllers/useAppThemeProviderController'
import { useLoadingStore } from '@/store/useLoadingStore'
import { Loading } from '../Loading'

export const AppThemeProvider = ({ children }: PropsWithChildren) => {
  const { theme, isCuraAPIReady } = useAppThemeProviderController()
  const setLoading = useLoadingStore.getState().setLoadingState

  useEffect(() => {
    setLoading(!isCuraAPIReady)

    return () => {
      setLoading(false)
    }
  }, [isCuraAPIReady, setLoading])

  if (!isCuraAPIReady) {
    return (
      <div style={{ height: '100%', width: '100%', display: 'flex' }}>
        <Loading />
      </div>
    )
  }

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
